import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginStore {
  setIsRememberMeChecked(checked: boolean) {
    localStorage.setItem('isRememberMeChecked', checked.toString());
  }

  getIsRememberMeChecked() {
    return localStorage.getItem('isRememberMeChecked');
  }

  setShake(stopped: boolean) {
    localStorage.setItem('isShakeStopped', stopped.toString());
  }

  getShake() {
    return localStorage.getItem('isShakeStopped');
  }

  setIsLoggedIn(loggedIn: boolean) {
    localStorage.setItem('isLoggedIn', loggedIn.toString());
  }

  getIsLoggedIn() {
    return localStorage.getItem('isLoggedIn');
  }

  removeIsLoggedIn() {
    localStorage.removeItem('isLoggedIn');
  }

  setIsTermsAgreed(agreed: boolean) {
    localStorage.setItem('isTermsAgreed', agreed.toString());
  }

  getIsTermsAgreed() {
    return localStorage.getItem('isTermsAgreed');
  }

  setDemoAccountName(accountName: string) {
    localStorage.setItem('demoAccountName', accountName);
  }

  getDemoAccountName() {
    return localStorage.getItem('demoAccountName');
  }

  setLoginEmail(loginEmail: string) {
    localStorage.setItem('loginEmail', loginEmail);
  }

  getLoginEmail() {
    return localStorage.getItem('loginEmail');
  }

  setPreviousEmail(previousEmail: string) {
    localStorage.setItem('previousEmail', previousEmail);
  }

  getPreviousEmail() {
    return localStorage.getItem('previousEmail');
  }

  getIsSignupPage() {
    return localStorage.getItem('isSignupPage');
  }

  setIsSignupPage(signupPage: true) {
    localStorage.setItem('isSignupPage', signupPage.toString());
  }

  removeIsSignupPage() {
    localStorage.removeItem('isSignupPage');
  }

  setReferralId(referralId: string) {
    localStorage.setItem('referralId', referralId);
  }

  getReferralId() {
    return localStorage.getItem('referralId');
  }

  setReferralCount(referralCount: string) {
    localStorage.setItem('referralCount', referralCount);
  }

  getReferralCount() {
    return localStorage.getItem('referralCount');
  }

  setReferralLink(link: string) {
    localStorage.setItem('referralLink', link);
  }

  getReferralLink() {
    return localStorage.getItem('referralLink');
  }

  setAppVersion(appVersion: string) {
    localStorage.setItem('appVersion', appVersion);
  }

  getAppVersion() {
    return localStorage.getItem('appVersion');
  }

  setDeviceId(deviceId: string) {
    localStorage.setItem('deviceId', deviceId);
  }

  getDeviceId() {
    return localStorage.getItem('deviceId');
  }

  setIsCordova(cordova: boolean) {
    localStorage.setItem('isCordova', cordova.toString());
  }

  getIsCordova() {
    return localStorage.getItem('isCordova');
  }

  setIsOldStorageCleared(cleared: boolean) {
    localStorage.setItem('isOldStorageCleared', cleared.toString());
  }

  getIsOldStorageCleared() {
    return localStorage.getItem('isOldStorageCleared');
  }

  setIsNotificationOpened(opened: boolean) {
    localStorage.setItem('isNotificationOpened', opened.toString());
  }

  getIsNotificationOpened() {
    return localStorage.getItem('isNotificationOpened');
  }

  setBanks(banks: any) {
    localStorage.setItem('banks', JSON.stringify(banks));
  }

  getBanks() {
    return JSON.parse(localStorage.getItem('banks'));
  }

  setUssdBanks(ussdBanks: any) {
    localStorage.setItem('ussdBanks', JSON.stringify(ussdBanks));
  }

  getUssdBanks() {
    return JSON.parse(localStorage.getItem('ussdBanks'));
  }

  setFilteredBanks(filteredBanks: any) {
    localStorage.setItem('filteredBanks', JSON.stringify(filteredBanks));
  }

  getFilteredBanks() {
    return JSON.parse(localStorage.getItem('filteredBanks'));
  }

  removeItemsOnLogout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('paymentMode');
    localStorage.removeItem('amount');
    localStorage.removeItem('isDateChanged');
    localStorage.removeItem('updatedId');
    localStorage.removeItem('referralLink');
    localStorage.removeItem('accounts');
    localStorage.removeItem('generalReportsDetails');
    localStorage.removeItem('cashiersReportsDetails');
  }

  clearOldStorage() {
    localStorage.clear();
  }
}
